import { ReportState, ReportAction, ReportActionTypes as ActionTypes } from './types';

const initialReportState: ReportState = {
  refresh: {},
  /** Load中か */
  isLoading: false,
  /** 月報フォーマットリストがLoad中か */
  isReportFormatListLoading: false,
  /** 送信処理中か */
  isSubmitting: false,
  /** 建物リスト */
  propertyList: [],
  /** 建物リストのページャ情報 */
  propertyListDisplayParams: {
    total: 0,
    total_page: 0,
    current_page: 0,
    sort: 0,
  },
  /** 契約先リスト */
  contractorList: [],
  /** 契約先リストのページャ情報 */
  contractorListDisplayParams: {
    total: 0,
    total_page: 0,
    current_page: 0,
    sort: 0,
  },
  reportTargetName: '',
  /** 月報出力対象リスト */
  reportItemList: [],
  /** 月報出力対象全リスト */
  reportItemListAll: [],
  /** 月報出力対象リストのページャ情報 */
  reportItemDisplayParams: {
    total: 0,
    total_page: 0,
    current_page: 0,
    sort: 0,
  },
  /** 月報フォーマットリスト */
  reportFormatList: [],
  /** 月報フォーマットリストのページャ情報 */
  reportFormatDisplayParams: {
    total: 0,
    total_page: 0,
    current_page: 0,
    sort: 0,
  },
  /** 選択中の月報フォーマット */
  selectedReportFormat: null,
  /** 選択された月報出力対象リスト */
  selectReportItemList: [],
};

const reportReducer = (
  state: ReportState = initialReportState,
  action: ReportAction,
): ReportState => {
  switch (action.type) {
    case ActionTypes.INIT:
      return initialReportState;

    case ActionTypes.REFRESH:
      return { ...state, refresh: {} };

    case ActionTypes.LOADING:
      return { ...state, isLoading: action.payload };

    case ActionTypes.REPORT_FORMAT_LIST_LOADING:
      return { ...state, isReportFormatListLoading: action.payload };

    case ActionTypes.SUBMITTING:
      return { ...state, isSubmitting: action.payload };

    case ActionTypes.SET_PROPERTY_LIST:
      return { ...state, propertyList: action.payload };

    case ActionTypes.SET_PROPERTY_LIST_DISPLAY_PARAMS:
      return { ...state, propertyListDisplayParams: action.payload };

    case ActionTypes.SET_CONTRACTOR_LIST:
      return { ...state, contractorList: action.payload };

    case ActionTypes.SET_CONTRACTOR_LIST_DISPLAY_PARAMS:
      return { ...state, contractorListDisplayParams: action.payload };

    case ActionTypes.SET_REPORT_TARGET_NAME:
      return { ...state, reportTargetName: action.payload };

    case ActionTypes.SET_REPORT_ITEM_LIST:
      return { ...state, reportItemList: action.payload };

    case ActionTypes.SET_REPORT_ITEM_LIST_ALL:
      return { ...state, reportItemListAll: action.payload };

    case ActionTypes.SET_REPORT_ITEM_DISPLAY_PARAMS:
      return { ...state, reportItemDisplayParams: action.payload };

    case ActionTypes.SET_REPORT_FORMAT_LIST:
      return { ...state, reportFormatList: action.payload };

    case ActionTypes.SET_REPORT_FORMAT_DISPLAY_PARAMS:
      return { ...state, reportFormatDisplayParams: action.payload };

    case ActionTypes.SET_SELECTED_REPORT_FORMAT:
      return { ...state, selectedReportFormat: action.payload };

    case ActionTypes.SET_SELECT_REPORT_ITEM_LIST:
      return { ...state, selectReportItemList: action.payload };

    default:
      return state;
  }
};

export default reportReducer;
